import { useSyncExternalStore } from "react";
import {
  applyMaterialentnahmeAppUpdate,
  getAppUpdateState,
  dismissMaterialentnahmeAppUpdateNotice,
  subscribeAppUpdate,
} from "../services/serviceWorkerService";

export function useAppUpdate() {
  const state = useSyncExternalStore(subscribeAppUpdate, getAppUpdateState, getAppUpdateState);
  return { ...state, applyUpdate: applyMaterialentnahmeAppUpdate, dismissNotice: dismissMaterialentnahmeAppUpdateNotice };
}
